import { render, staticRenderFns } from "./setmember.vue?vue&type=template&id=f6972ade&scoped=true&"
import script from "./setmember.vue?vue&type=script&lang=js&"
export * from "./setmember.vue?vue&type=script&lang=js&"
import style0 from "./setmember.vue?vue&type=style&index=0&id=f6972ade&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6972ade",
  null
  
)

export default component.exports